export const stage1WorkspacePath = '/CDP/workspace'
export const stage1RuntimePath = '/CDP/runtime'

export const stage1Groups = [
  {
    title: '数据接入与运行',
    items: [
      { path: '/CDP/data-sources', title: '数据源管理' },
      { path: '/CDP/batch', title: '仓内批任务' }
    ]
  },
  {
    title: '数据资产与治理',
    items: [
      { path: '/CDP/metadata', title: '数据字典' },
      { path: '/CDP/quality', title: '数据质量' }
    ]
  },
  {
    title: '标签资产',
    items: [{ path: '/CDP/tag-batch', title: '标签体系' }]
  },
  {
    title: '客户 360',
    items: [{ path: '/CDP/customer-context', title: '客户 360' }]
  }
]

const stage1Paths = new Set(
  stage1Groups
    .reduce(
      (paths, group) => paths.concat(group.items.map(item => item.path)),
      []
    )
    .concat([
      stage1WorkspacePath,
      '/CDP/entities',
      '/CDP/feature-dictionary',
      '/CDP/privacy'
    ])
)

function normalizedPath(url) {
  if (typeof url !== 'string') return ''
  const path = url.replace(/^\.\./, '').split('?')[0]
  return path.startsWith('/') && !path.startsWith('//') && !path.includes('..')
    ? path
    : ''
}

function collectLinks(nodes, links = []) {
  if (!Array.isArray(nodes)) return links
  nodes.forEach(node => {
    if (!node) return
    const ownPath = normalizedPath(node.url)
    if (ownPath)
      links.push({
        path: ownPath,
        title: node.displayName || node.name || ownPath
      })
    if (Array.isArray(node.views)) {
      node.views.forEach(view => {
        const path = normalizedPath(view && view.url)
        if (path)
          links.push({
            path,
            title: view.name || view.displayName || node.displayName || path
          })
      })
    }
    collectLinks(node.children, links)
  })
  return links
}

// The server menu is the visibility source; the design map only reorganizes granted routes.
export function buildStage1Navigation(menuData) {
  const applications = Array.isArray(menuData) ? menuData : []
  const cdpApplication = applications.find(application =>
    collectLinks(application.menu).some(link => link.path.startsWith('/CDP/'))
  )
  const grantedLinks = cdpApplication ? collectLinks(cdpApplication.menu) : []
  const grantedPaths = new Set(grantedLinks.map(link => link.path))
  const dictionaryLanding = [
    '/CDP/metadata',
    '/CDP/entities',
    '/CDP/feature-dictionary',
    '/CDP/privacy'
  ].find(path => grantedPaths.has(path))
  const groups = stage1Groups
    .map(group => ({
      ...group,
      items: group.items
        .map(item =>
          item.path === '/CDP/metadata' && dictionaryLanding
            ? { ...item, path: dictionaryLanding }
            : item
        )
        .filter(item => grantedPaths.has(item.path))
    }))
    .filter(group => group.items.length > 0)
  // The landing page must be a real server-granted Stage 1 page, never an implicit portal.
  const landingPath = groups.length ? groups[0].items[0].path : null

  const legacy = []
  const seen = new Set()
  if (cdpApplication && Array.isArray(cdpApplication.menu)) {
    cdpApplication.menu.forEach(section => {
      const items = collectLinks([section]).filter(item => {
        // A server-side legacy grant must not resurrect the retired monitor in the old menu.
        if (
          stage1Paths.has(item.path) ||
          item.path === stage1RuntimePath ||
          seen.has(item.path)
        )
          return false
        seen.add(item.path)
        return true
      })
      if (items.length)
        legacy.push({
          title: section.displayName || section.name || '原有功能',
          items
        })
    })
  }

  // Keep one navigation entry for the granted legacy CDP workspace; its own shell owns its menu.
  const legacyPaths = legacy.reduce(
    (items, group) => items.concat(group.items),
    []
  )
  const legacyLanding =
    ['/CDP/Kanban/Member', '/CDP/Kanban/Customer']
      .map(path => legacyPaths.find(item => item.path === path))
      .find(Boolean) || legacyPaths[0]
  const legacyEntry = legacyLanding
    ? { path: legacyLanding.path, title: '历史功能' }
    : null

  return { groups, legacy, legacyEntry, grantedPaths, landingPath }
}
